import React from 'react';
import { Box, Typography, Link, Container, useTheme } from '@mui/material';

const AppFooter = () => {
  const theme = useTheme();
  
  const handlePrivacyClick = () => {
    window.open('/privacy', '_blank');
  };
  
  const handleTermsClick = () => {
    window.open('/terms', '_blank');
  };

  const handleICPClick = () => {
    window.open('https://beian.miit.gov.cn/', '_blank');
  };
  
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: 'white',
        borderTop: '1px solid rgba(0, 0, 0, 0.08)',
        py: 3,
        mt: 'auto'
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'center',
            alignItems: 'center',
            gap: { xs: 1, sm: 3 },
            textAlign: 'center'
          }}
        >
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontSize: '0.875rem' }}
          >
            © 2026 PageSmooth. 保留所有权利
          </Typography>

          <Box>
            <Link
              component="button"
              variant="body2"
              onClick={handleICPClick}
              sx={{
                color: 'text.secondary',
                textDecoration: 'none',
                fontSize: '0.875rem',
                cursor: 'pointer',
                transition: 'color 0.2s ease',
                '&:hover': {
                  color: theme.palette.primary.main
                },
                '&:active': {
                  color: theme.palette.primary.main
                }
              }}
            >
              豫ICP备2025127472号
            </Link>
          </Box>

          <Box
            sx={{
              display: 'flex',
              gap: 2,
              alignItems: 'center'
            }}
          >
            <Link
              component="button"
              variant="body2"
              onClick={handlePrivacyClick}
              sx={{
                color: 'text.secondary',
                textDecoration: 'none',
                fontSize: '0.875rem',
                cursor: 'pointer',
                transition: 'color 0.2s ease',
                '&:hover': {
                  color: theme.palette.primary.main
                },
                '&:active': {
                  color: theme.palette.primary.main
                }
              }}
            >
              隐私协议
            </Link>    
            <Link
              component="button"
              variant="body2"
              onClick={handleTermsClick}
              sx={{
                color: 'text.secondary',
                textDecoration: 'none',
                fontSize: '0.875rem',
                cursor: 'pointer',
                transition: 'color 0.2s ease',
                '&:hover': {
                  color: theme.palette.primary.main
                },
                '&:active': {
                  color: theme.palette.primary.main
                }
              }}
            >
              用户协议
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default AppFooter; 